export const WINDOW_BREAKPOINTS = {
    TABLET: 768, // md
    LAPTOP: 1024, // lg
    DESKTOP: 1440, // xl
}

